import { userInfoType } from 'types';

const extractSemelFromSession = (session: string = ''): string => {
  if (!session) return '';
  const match = session.match(/(?:semel[_]?mosad|semelMossad)=([^&]+)/i);
  if (match && match[1]) {
    return decodeURIComponent(match[1]);
  }
  return '';
};

export const getSemelFromUserInfo = (userInfo: userInfoType): string => {
  const directValue = userInfo.semelMosad?.trim();
  if (directValue) {
    return directValue;
  }
  const fromSession = extractSemelFromSession(userInfo.session);
  return fromSession.trim();
};

export default getSemelFromUserInfo;

